import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL:
//     process.env.REACT_APP_API_URL ||
//     "https://api.radioharivarasanam.com/" /*"http://192.168.1.23:8080/"*/,
// });
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.radionellikka.com/",
  // baseURL: "http://127.0.0.1:8080/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
